import { Component, Input, OnInit } from "@angular/core";
import { IVTableColumn } from "@app/directives/_layout/v-table/_models/IVTableColumn";
import { IVTableRow } from "@app/directives/_layout/v-table/_models/IVTableRow";
import { VTableService } from "@app/directives/_layout/v-table/_services/v-table.service";
import { SortDirection } from "@app/enum/SortDirection";
import { SortType } from "@app/enum/SortType";
import { EBPMSStatusIconComponent } from "../ebpms-status-icon/ebpms-status-icon.component";
import { IBrakePerformanceScoreHistory } from "../_models/IBrakePerformanceScoreHistory";
import "./ebpms-score-history-table.component.scss";

@Component({
    selector: 'ebpms-score-history-table',
    template: require("./ebpms-score-history-table.component.html")
})
export class EBPMSScoreHistoryTableComponent implements OnInit {
    @Input() history: IBrakePerformanceScoreHistory[];

    // ---

    tableColumns: IVTableColumn<IBrakePerformanceScoreHistory>[] = [];
    tableRows: IVTableRow<IBrakePerformanceScoreHistory>[] = [];

    loading = false;

    constructor(
        private readonly vTableService: VTableService) {
    }

    ngOnInit(): void {
        this.loading = true;

        this.createTableColumns();

        this.loading = false;
    }

    ngOnChanges(): void {
        this.tableRows = this.vTableService.createTableRows(this.history, this.tableColumns);
    }

    // ---

    private createTableColumns(): void {
        this.tableColumns = [
            {
                header: this.vTableService.createDateTableHeader({ sorted: true, sortDirection: SortDirection.Descending }),
                createCellFunction: (data) => this.vTableService.createDateCell(data.CalculatedTime)
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "Common.Status", sortType: SortType.String, width: 100 }),
                createCellFunction: (data) => this.vTableService.createTableCell(data.Score, { component: EBPMSStatusIconComponent, componentInputs: { ebpmsStatus: data.Status } })
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "MaintenanceOverview.Bpv", width: 140 }),
                createCellFunction: (data) => {
                    const result = data.Score == null ? "--" : data.Score.toFixed(1) + "%";
                    return this.vTableService.createTableCell(result);
                }
            }
        ]
    }
}
